import React from 'react';

import {
  Button,
  ButtonGroup
} from 'reactstrap';

import { NavLink } from 'react-router-dom';
import ReactTable from "react-table";
import "react-table/react-table.css";

import { FaPencilSquare, FaFileText } from 'react-icons/lib/fa/';



class ListagemProcessos extends React.Component {

  meuOnClick = (p1, p2, p3) => console.log(p1, p2, p3);

  render() {
    const data = this.props.processos
      .map(processo => ({
        ...processo,
        tiposAlegacao: processo.tiposAlegacao.reduce((acu, atual) => `${acu}${atual.descricao}, `, "")
      }));

    return (
      <div>

        <ReactTable
          data={data}

          columns={[
            {
              columns: [
                {
                  Header: "NÚMERO PROCESSO",
                  accessor: "id",
                  minWidth: 70,
                  onClick: e => this.meuOnClick(e)
                },
                {
                  Header: "RESPONSÁVEL",
                  accessor: "usuario.nome"
                },
                {
                  Header: "ALEGAÇÕES",
                  accessor: "tiposAlegacao"
                },

                {
                  Header: "SITUAÇÃO",
                  accessor: "situacao.descricao",
                  minWidth: 50
                },
                {
                  Header: "DATA APRESENTAÇÃO",
                  accessor: "dataApresentacaoText",
                  minWidth: 50,
                  Cell: ({ row: { dataApresentacaoText } }) =>
                    (new Date(dataApresentacaoText)).toLocaleDateString()

                },
                {
                  Header: "DATA MODIFICAÇÃO",
                  accessor: "dataUltimaAtualizacaoText",
                  minWidth: 50,
                  Cell: ({ row: { dataUltimaAtualizacaoText } }) =>
                    (new Date(dataUltimaAtualizacaoText)).toLocaleDateString()
                },
                {
                  Header: "AÇÕES",
                  Cell: ({ row: { id, "situacao.descricao": descricao } }) =>
                    <ButtonGroup size="sm">
                      <Button className="btn-ico" title="Detalhar" tag={NavLink} to={`/processo/${id}/tramitar/${descricao}`} ><FaFileText size="18" /></Button>
                      {
                        descricao === "Preparado" && <Button className="btn-ico" title="Atualizar" tag={NavLink} to={`/processo/${id}/atualizar`} ><FaPencilSquare size="40"/></Button>
                      }
                    </ButtonGroup>
                }
              ]
            }
          ]}

          previousText='Anterior'
          nextText='Próxima'
          loadingText='Carregando...'
          noDataText='Nenhum registro encontrado'
          pageText='Página'
          ofText='de'
          rowsText='linhas'

          defaultPageSize={5}
          className="-striped -highlight"


        />
        <br />
      </div>
    );
  }

}

export default ListagemProcessos;



// WEBPACK FOOTER //
// ./src/componentes/ListagemProcessos.js